module.exports = __webpack_public_path__ + "img/tick-square.47eda8a9.svg";